import React, { FC, useEffect, useState } from 'react';
import {
  ConfirmationPopupProps,
  ConfirmationPopupState,
  PageWrapper,
  User,
  UserForm,
} from '@dew21/ui';
import { useHistory, useParams } from 'react-router';
import axios from 'axios';
import { useShowAlertPopup } from '@dew21/ui';
import { useSetRecoilState } from 'recoil';

export const EditUser: FC = (props) => {
  const { id } = useParams();
  const history = useHistory();
  const showNotificationBanner = useShowAlertPopup();
  const [user, setUser] = useState<User | null>(null);
  const setShowDeletePopup = useSetRecoilState<ConfirmationPopupProps>(ConfirmationPopupState);

  const fetchUser = () => {
    return axios.get(`/api/users/${id}`);
  };

  const deleteUser = () => {
    return axios.delete(`/api/users/${id}`);
  };

  useEffect(() => {
    if (id) {
      fetchUser().then((response) => {
        setUser(response.data);
      }).catch((e) => {
        console.log(e);
      });
    }
  }, []);

  return <PageWrapper
    breadCrumb={[{ title: 'Benutzer', path: '/users' }, { title: 'Bearbeiten', path: `/users/${id}` }]}
    marginal={{
      items: [
        {
          text: 'Benutzer löschen',
          icon: 'trash',
          actionFn: () => {
            setShowDeletePopup({
              config: {
                open: true,
                actionButtonLabel: 'Löschen',
                closeFn: () => {
                  setShowDeletePopup({ config: null });
                },
                renderer: () => {
                  return <>Möchten Sie den Benutzer wirklich löschen?</>;
                },
                actionFn: () => {
                  deleteUser().then((response) => {
                    showNotificationBanner({ renderContent: () => <>Der Benutzer wurde erfolgreich gelöscht.</> });
                    setShowDeletePopup({ config: null });
                    history.push('/users');
                  }).catch((error) => {
                    console.log(error);
                    showNotificationBanner({
                      error: true,
                      renderContent: () => <>Bei dem Versuch den Benutzer zu löschen ist ein Fehler aufgetreten.</>,
                    });
                  });
                },
              },
            });
          },
        }],
    }}>
    {user !== null ? <UserForm
      onCancel={() => {
        history.push('/users');
      }}
      user={user}
      onChange={(payload) => {
        axios.put(`/api/users/${user.id}`, payload).then((response) => {
          setUser(response.data);
          showNotificationBanner({ renderContent: () => <>Ihre änderungen wurden gepeichert.</> });
          history.push('/users');
        }).catch((error) => {
          showNotificationBanner({ error: true, renderContent: () => <>Bitte kontrolieren Sie ihre Eingaben.</> });
          console.log(error);
        });
      }} /> : 'Benutzer nicht gefunden'}
  </PageWrapper>;
};
